var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dispensing-item-preview"},[_c('v-btn',{attrs:{"disabled":_vm.readOnlyRules,"color":"primary","small":"","outlined":"","rounded":""},on:{"click":function($event){return _vm.switchToAeTab()}}},[_vm._v(_vm._s(_vm.t('patients::button.fill_in_ae_form')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }